module.exports = __webpack_public_path__ + "img/yun.4cd6edb7.png";